module.exports = __webpack_public_path__ + "img/rulebg.80a9826d.png";